import { DateTimeField } from "@/src/components";
import {
    AutocompleteInput, BooleanField, BooleanInput, Datagrid, DateField, List, ListProps, Pagination,
    ReferenceField, ReferenceInput, TextField
} from "react-admin";


const rowSx = (record: any) => {
    return {
        backgroundColor: record?.deleted && "#e6c8c85b",
    }
}

export const UserLikeList = (props: ListProps) => (
    <List {...props}
        filters={filters}
        sort={{ field: 'updatedAt', order: 'DESC' }}
        perPage={100}
        pagination={<UserLikeListPagination />}
        exporter={false}
    >
        <Datagrid
            rowClick="edit" rowSx={rowSx}
            bulkActionButtons={false}
        >
            {/* <TextField source="id" /> */}
            <ReferenceField label="Actor(Liker)" source="actor" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            {/* <TextField source="actor" /> */}
            <ReferenceField label="Subject(Liked)" source="subject" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <DateTimeField source="createdAt" />
            <DateTimeField source="updatedAt" />
            <BooleanField source="deleted" />
            <DateField source="deletedAt" />
        </Datagrid>
    </List>
);

const UserLikeListPagination = () => <Pagination rowsPerPageOptions={[50, 100, 200]} />;
const filters = [
    <ReferenceInput label="Actor(Liker)" source="actor" reference="user" allowEmpty alwaysOn >
        <AutocompleteInput optionText="profile.nickname"
            filterToQuery={(txt) => ({ profile: { nickname: txt } })}
            size='small' />
    </ReferenceInput>,
    <ReferenceInput label="Subject(Liked)" source="subject" reference="user" allowEmpty alwaysOn >
        <AutocompleteInput optionText="profile.nickname"
            filterToQuery={(txt) => ({ profile: { nickname: txt } })}
            size='small' />
    </ReferenceInput>,
    <BooleanInput label="Deleted" source="withDeleted" alwaysOn size='medium' sx={{ padding: "4px" }} />
]
